export default __webpack_public_path__ + "static/project-stashly-28b68a6119d4257f8a40b6178db4dfa7.png";